import PropTypes from 'prop-types';

import LinearProgress from '@mui/material/LinearProgress';

import useBlockingPageLoad from 'hooks/useBlockingPageLoad';

/**
 * Thin top-of-panel loading indicator. Renders nothing when inactive.
 * Pass `blockingOnly` to hide after the first successful load (smooth tab / refetch UX).
 */
export default function PageLoadingBar({ active, blockingOnly = true, sx }) {
  const blocking = useBlockingPageLoad(active);
  const visible = blockingOnly ? blocking : active;

  if (!visible) {
    return null;
  }

  return <LinearProgress sx={{ flexShrink: 0, ...sx }} />;
}

PageLoadingBar.propTypes = {
  active: PropTypes.bool,
  blockingOnly: PropTypes.bool,
  sx: PropTypes.object
};
